import { requestApi, HttpMethods } from '~/services/api-new';
import { TypeOrNull } from '../../types';

type Tcvv = {
	amount: TypeOrNull<number>;
	paymentMethodId?: TypeOrNull<number>;
	playerCardId?: number;
	providerId?: number;
};

export const fetchCVVBypass = async (payload: Tcvv) => {
	const response = await requestApi({
		endpoint: `/CreditCardIntegration/client/rest/bypass/cvv/isBypass`,
		payload,
		method: HttpMethods.POST
	});

	return response;
};

export const getCreditCardEncryptionKey = async () =>
	requestApi<{ result?: string }>({ endpoint: `/CreditCardIntegration/getCreditCardKey` });
